import { Button, Row } from "antd";
import { HowToPayModal } from "./HowToPayModal";
import { useCallback, useState } from "react";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { NavigateFunction, useNavigate, useParams } from "react-router";
import ROUTES from "../../../../../../configs/routesConfig";
import { useHasDeepPaymentProviderIntegrationAccess } from "../../../../../../lib/hooks/useHasDeepPaymentProviderIntegrationAccess";

type PaySction = {
  allowOnlinePayments: boolean;
};

export const PaySection = ({ allowOnlinePayments }: PaySction) => {
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

  const navigate: NavigateFunction = useNavigate();

  const { accountId } = useParams();

  const { canViewDeepPaymentProviderIntegration } =
    useHasDeepPaymentProviderIntegrationAccess();

  const openModal = useCallback(() => setIsOpenModal(true), []);

  const closeModal = useCallback(() => setIsOpenModal(false), []);

  const onPayClick = useCallback(() => {
    canViewDeepPaymentProviderIntegration
      ? navigate(`${ROUTES.ACCOUNTS}/${accountId}/payment`)
      : window.open(
          "https://app.fluidpay.com/spp/sunwest-pay-my-bill",
          "_blank",
        );
  }, [accountId, navigate, canViewDeepPaymentProviderIntegration]);

  return (
    <Row>
      {allowOnlinePayments ? (
        <>
          <Button
            size="large"
            type="primary"
            shape="round"
            onClick={onPayClick}
          >
            Pay Escrow
          </Button>
          <QuestionCircleOutlined
            onClick={openModal}
            className="logo-cursor ml-4 text-md title"
          />
          <HowToPayModal
            isModalOpen={isOpenModal}
            close={closeModal}
            onPay={onPayClick}
          />
        </>
      ) : (
        <Row>
          <p className="text-sm w-500 title my-0 py-1">
            Online payment has been disabled. Please contact us or visit our
            office to make payments. Thank you.
          </p>
        </Row>
      )}
    </Row>
  );
};
